import { render, staticRenderFns } from "./collectionRecords.vue?vue&type=template&id=19e3094b&scoped=true"
import script from "./collectionRecords.vue?vue&type=script&lang=js"
export * from "./collectionRecords.vue?vue&type=script&lang=js"
import style0 from "./collectionRecords.vue?vue&type=style&index=0&id=19e3094b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e3094b",
  null
  
)

export default component.exports